import currency from './constant/currency'
import country from './constant/country'
import province from './constant/province'

const initState = () => ({
	currency:currency,
	country:country,
	province:province,
	mentorDetail:'',
    user:'',
    token:'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6IjVjZGJmZTcwMGExOWViMTBhNGU1MDdmNyIsImlhdCI6MTU1ODkyODkyMH0.9PXT6F5LxA_YMQ8jOx0znclkZXeDIG82EycGysieaTc',
  menTorList:'',
  modalReviewOpen:false
  });
  
  export default initState;
  